import { NavLink } from "react-router-dom";
import FlagToggle from "../../../mainApp/features/Hooks/FlagToggle.js";
import styled, { css } from "styled-components";
import { Link } from "react-scroll";
import { ReactComponent as SunIcon } from "../../../mainApp/images/SunIcon.svg";
import { ReactComponent as DragonIcon } from "../../../mainApp/images/DragonIcon.svg";

export const ProfileImage = styled.img`
  width: 36px; 
  height: 36px;
  border-radius: 50%; /* Okrągłe zdjęcie */
  object-fit: cover; /* Dopasowanie zdjęcia */
  transition: all 0.3s ease-in-out;
  position: absolute; /* Nakładanie na skeleton */
  top: 0;
  left: 0;
  z-index: 1; /* Wyższy niż skeleton */
  opacity: 1;

  ${({ isSkeletonVisible }) =>
    !isSkeletonVisible &&
    css`
      &:hover {
        transform: scale(1.1); /* Efekt powiększenia przy najechaniu */
        cursor: pointer;
      }
    `}

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    width: 27px;
    height: 27px;
  }
`;

export const NavigationBackground = styled.div`
  z-index: 1000;
  height: 104px;
  width: 100%;
  min-width: 320px;
  position: fixed;
  top: ${(props) => (props.visible ? "0" : "-120px")};
  transition: top 0.3s, background-color 0.6s ease;
`;

export const StyledFlagToggle = styled(FlagToggle)`
  transition: transform 0.6s;
  ${({ $themes }) =>
    $themes &&
    css`
      transform: translateX(100%);
    `};
`;

export const NavigationList = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 24px 11px;
  list-style-type: none;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    padding: 24px 8px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 32px 12px;
    row-gap: 20px;
  }
`;

export const NavigationLink = styled(NavLink)`
  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.fontcolor};
  text-decoration: none;
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-top: 2px;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    font-size: 15px;
  }
  &:hover {
    color: ${({ theme, isNoon }) => (isNoon ? theme.color.dragonOrange : theme.color.dragonRed)};
  }
`;

export const NavigationLinkRed = styled.a`
  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.fontcolor};
  text-decoration: none;
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-top: 2px;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    font-size: 15px;
  }
  &:hover {
    color: ${({ theme }) => theme.color.dragonRed};
  }
`;

export const NavScrollLink = styled(Link)`
  cursor: pointer;
  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.fontcolor};
  text-decoration: none;
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-top: 2px;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  &:hover {
    color: ${({ theme, isNoon }) => (isNoon ? theme.color.dragonOrange : theme.color.dragonRed)};
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    font-size: 15px;
  }
`;

export const NavigationLogo = styled.div`
  font-weight: ${({ theme }) => theme.fontSize.medium};
  display: flex;
  flex-wrap: nowrap;
  color: ${({ theme }) => theme.color.white};
  margin-left: 20px;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    margin-top: 8px;
    height: 17px;
    font-size: 15px;
    margin-left: 10px;
  }
`;

export const Dragon = styled.img`
  transition: 0.3s;
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
  &:hover {
    scale: 105%;
  }
`;

export const NavigationLogoLink = styled(NavLink)`
  text-decoration: none;
  pointer-events: ${({ isLoading }) => (isLoading ? "none" : "auto")};
  @media (min-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    margin-right: 50px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    font-size: 15px;
  }
`;

export const NavigationLogoScrollLink = styled(Link)`
  text-decoration: none;
  pointer-events: ${({ isLoading }) => (isLoading ? "none" : "auto")};
  @media (min-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    margin-right: 50px;
  }
  cursor: pointer;
`;

export const IconBody = styled.button`
  position: relative;
  pointer-events: none;
  cursor: not-allowed;
  width: 47px;
  height: 27px;
  padding: 2px;
  border: 1px solid #6e7e91;
  border-radius: 15px;
  background: ${({ theme }) => theme.color.spotifyBlack};
   ${({ $themes }) =>
    $themes &&
    css`
      background: ${({ theme }) => theme.color.text};
    `};
  transition: background-color 1s cubic-bezier(0.69, 0.15, 0.31, 0.85);
  &:hover {
    cursor: pointer;
  }
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
`;

export const ModeChange = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px; /* Odstęp między elementami ModeChange */
  margin-left: auto; /* Przesuwa elementy maksymalnie w prawo */
  margin-right: 20px; /* Dodaje odstęp od prawej krawędzi */
  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    margin-right: 10px; /* Mniejszy odstęp na mniejszych ekranach */
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    margin-left: 0;
    margin-right: 0;
    justify-content: center;
    width: 100%;
  }
`;

export const FlagIconBody = styled.button`
  width: 47px;
  height: 27px;
  padding: 2px;
  border: 1px solid #6e7e91;
  border-radius: 15px;
  background: ${({ theme }) => theme.color.darkModeBackground};
  transition: background-color 1s cubic-bezier(0.69, 0.15, 0.31, 0.85);
  &:hover {
    cursor: pointer;
  }
`;

export const Body = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  transition: all 1.3s ease;
`;

export const DarkMode = styled.div`
  color: #6e7e91;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  flex-direction: row-reverse;
  gap: 12px;
 padding: 7px;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
    display: none;
  }
`;

export const StyledSunIcon = styled(SunIcon)`
  transition: transform 0.6s;
  ${({ $themes }) =>
    $themes &&
    css`
      transform: translateX(100%) rotate(180deg);
    `};
`;
export const StyledDragonIcon = styled(DragonIcon)`
  transition: transform 0.6s;
  ${({ $themes }) =>
    $themes &&
    css`
      // transform: translateX(100%) rotate(180deg);
    `};
`;

export const PremiumBadge2 = styled.div`
${({ isAi }) =>
    isAi &&
    css`
      position: absolute;
      top: 15px;    // Poprawiono komentarz — to ujemna wartość
      right: -23px;  // To również ujemna wartość
    `}
  background: linear-gradient(90deg, #ffdb4d 0%, #ff8c00 100%);
  color: #000;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 4px;
  border-radius: 12px;
  z-index: 2;
  rotate: -30deg;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
`;

export const ProfileMenuWrapper = styled.div`
  position: relative;
  display: inline-block;
  pointer-events: ${({ isLoading }) => (isLoading ? "none" : "auto")};
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
`;

export const ProfileMenu = styled.div`
  position: absolute;
  top: calc(100% + 3vh); /* Przesunięcie o 5vh w dół od górnej krawędzi rodzica */
  right: 0;
  width: 240px;
  background: ${({ theme }) => theme.color.spotifyDarkGrey};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  transform-origin: top;
  transform: ${({ isOpen }) => (isOpen ? 'scaleY(1)' : 'scaleY(0)')};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: transform 0.3s ease, opacity 0.2s ease;
  z-index: 2000;
`;

export const ProfileMenuHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: ${({ theme }) => theme.color.spotifyDarkerGrey};
  border-bottom: 1px solid ${({ theme }) => theme.color.spotifyLightGrey};
`;

export const ProfileMenuImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
  object-fit: cover;
`;

export const ProfileMenuName = styled.span`
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 14px;
  font-weight: 600;
`;

export const ProfileMenuItem = styled(NavLink)`
  width: 100%;
  text-align: left;
  padding: 10px 16px;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.color.spotifyGrey};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  text-decoration: none; // Reset domyślnych stylów linku
  display: block; // NavLink renderuje się jako <a>, więc ustawiamy display: block

  &:hover {
    background: ${({ theme }) => theme.color.spotifyLightGrey};
    color: ${({ theme }) => theme.color.spotifyWhite};
  }
`;

export const ProfileMenuDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.color.spotifyLightGrey};
  margin: 8px 0;
`;

export const TokensContainer = styled.div`
  display: flex;
  align-items: center;
  color: white;
  margin-right: 12px;
  background-color: #282828;
  padding: 6px 12px;
  border-radius: 20px;
  font-family: 'CircularSp', sans-serif;
  font-weight: 500;
  font-size: 14px;
`;

export const TokensIcon = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  color: #FFD700; // Złoty kolor dla monety
`;

export const TokensValue = styled.span`
  color: #FFFFFF;
`;

export const SubscriptionBadge = styled.div`
  font-size: 14px;
  font-weight: 700;
  margin-right: 12px;
  font-family: 'CircularSp', sans-serif;
  color: #FFFFFF; /* Domyślny kolor dla Standard */

  ${({ isPremium }) =>
    isPremium &&
    css`
      background: linear-gradient(90deg, #ffdb4d 0%, #ff8c00 100%);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    `}
`;